<template>
  <form-template @send-data="sendData" @delete-data="deleteData" :mode="mode">
    <v-text-field
      class="required"
      label="Standort-Name"
      :rules="rules.name"
      v-model.trim="input.name"
    ></v-text-field>
    <v-text-field
      label="Art des Standortes"
      :rules="rules.type"
      v-model.trim="input.type"
    ></v-text-field>
    <v-text-field
      class="required"
      label="Besitzer des Standortes (exakten Firmennamen eintragen!)"
      :rules="rules.owner"
      v-model.trim="input.owner"
    ></v-text-field>
    <v-text-field
      class="required"
      label="Straße"
      v-model.trim="input.street"
      :rules="rules.street"
    ></v-text-field>
    <v-text-field
      class="required"
      label="Hausnr."
      v-model.trim="input.houseNumber"
      :rules="rules.houseNumber"
    ></v-text-field>
    <v-text-field
      class="required"
      label="PLZ"
      v-model.trim="input.postalCode"
      :rules="rules.postalCode"
    ></v-text-field>
    <v-text-field
      class="required"
      label="Ort"
      v-model.trim="input.district"
      :rules="rules.district"
    ></v-text-field>
    <p><span style="color: red">*</span> notwendige Eingabe</p>
    <br />
  </form-template>
</template>

<script lang="ts">
import FormTemplate from "./FormTemplate.vue";
import { useOfficeStore } from "../../store/officeStore";
import { mapStores } from "pinia";

export default {
  data() {
    return {
      input: {
        name: "" as string,
        type: "" as string,
        owner: "" as string,
        street: "" as string,
        houseNumber: "" as string,
        postalCode: "" as string,
        district: "" as string,
        lon: null as number | null,
        lat: null as number | null,
      },
      rules: {
        name: [
          (val: string) => {
            if (!val) {
              return "Name notwendig.";
            }
            return val.length > 0 || "Name notwendig.";
          },
        ],
        type: [
          (val: string) => {
            if (!val) {
              return "Art des Standorts notwendig.";
            }
            return val.length > 0 || "Art des Standorts notwendig.";
          },
        ],
        owner: [],
        street: [
          (val: string) => {
            if (!val) {
              return "Straße notwendig.";
            }
            return val.length > 0 || "Straße notwendig.";
          },
        ],
        houseNumber: [
          (val: string) => {
            if (!val) {
              return "Hausnummer notwendig.";
            }
            return val.length > 0 || "Hausnummer notwendig.";
          },
        ],
        postalCode: [
          (val: string) => {
            if (!val) {
              return "PLZ notwendig.";
            }
            return val.length > 0 || "PLZ notwendig.";
          },
        ],
        district: [
          (val: string) => {
            if (!val) {
              return "Ortschaft notwendig.";
            }
            return val.length > 0 || "Ortschaft notwendig.";
          },
        ],
      },
    };
  },
  mounted() {
    // @ts-ignore
    if (this.mode === "put") {
      // @ts-ignore
      this.input.name = this.name;
      // @ts-ignore
      this.input.type = this.type;
      // @ts-ignore
      this.input.owner = this.owner;
      // @ts-ignore
      this.input.street = this.street;
      // @ts-ignore
      this.input.houseNumber = this.house_number;
      // @ts-ignore
      this.input.postalCode = this.postal_code;
      // @ts-ignore
      this.input.district = this.district;
    } else {
      for (let key in this.input) {
        // @ts-ignore
        this.input[key] = null;
      }
    }
  },
  components: { FormTemplate },
  computed: {
    ...mapStores(useOfficeStore),
  },
  watch: {
    mode(newVal) {
      if (newVal === "put") {
        // @ts-ignore
        this.input.name = this.name;
        // @ts-ignore
        this.input.type = this.type;
        // @ts-ignore
        this.input.owner = this.owner;
        // @ts-ignore
        this.input.street = this.street;
        // @ts-ignore
        this.input.houseNumber = this.house_number;
        // @ts-ignore
        this.input.postalCode = this.postal_code;
        // @ts-ignore
        this.input.district = this.district;
        // @ts-ignore
        this.input.lon = this.lon;
        // @ts-ignore
        this.input.lat = this.lat;
      } else {
        for (let key in this.input) {
          // @ts-ignore
          this.input[key] = null;
        }
      }
    },
  },
  emits: {
    // validation is done in the form
    "post-office": () => {
      return true;
    },
    "put-office": () => {
      return true;
    },
    "delete-office": () => {
      return true;
    },
  },
  props: {
    name: {
      type: String || null,
      default: null,
      required: false,
    },
    owner: {
      type: String || null,
      default: null,
      required: false,
    },
    type: {
      type: String || null,
      default: null,
      required: false,
    },
    street: {
      type: String || null,
      default: null,
      required: false,
    },
    house_number: {
      type: String || null,
      default: null,
      required: false,
    },
    postal_code: {
      type: String || null,
      default: null,
      required: false,
    },
    district: {
      type: String || null,
      default: null,
      required: false,
    },
    lon: {
      type: Number || null,
      default: null,
      required: false,
    },
    lat: {
      type: Number || null,
      default: null,
      required: false,
    },
    mode: {
      type: String || null,
      required: true,
      validator(val: string) {
        return val === "post" || val === "put";
      },
    },
    currentId: {
      type: Number || null,
      required: false,
      default: null,
    },
    projectId: {
      type: Number || null,
      required: false,
      default: null,
    },
    companyId: {
      type: Number || null,
      required: false,
      default: null,
    },
    adressId: {
      type: Number || null,
      required: false,
      default: null,
    },
  },
  methods: {
    async sendData() {
      // @ts-ignore
      if (!(this.companyId && this.projectId)) {
        console.warn(
          "Send-data operation was not completed, due to lack of required data. company-identifier and/ or project-identifier not given.",
        );
        return;
      }
      // we can be sure, that data will be available, because form is already validated
      let office = {
        name: this.input.name,
      };
      if (this.input.type) {
        // @ts-ignore
        office["type"] = this.input.type;
      }
      if (this.input.owner) {
        // @ts-ignore
        office["owner"] = this.input.owner;
      }
      if (this.input.street) {
        // @ts-ignore
        office["adress"] = {
          street: this.input.street,
          house_number: this.input.houseNumber,
          postal_code: this.input.postalCode,
          district: this.input.district,
        };
      }
      // check form mode and decide for put or post operation
      // @ts-ignore
      if (this.mode === "post") {
        try {
          await this.officeStore.postOffice(
            office,
            // @ts-ignore
            this.projectId,
            // @ts-ignore
            this.companyId,
          );
          this.$emit("post-office");
        } catch (e) {
          console.warn(
            // @ts-ignore
            `Post of office was not successful, error with message: ${e.message}, thrown`,
          );
          return;
        }
        // @ts-ignore
      } else if (this.mode === "put") {
        // @ts-ignore
        if (!(this.currentId && this.adressId)) {
          console.warn(
            "put-office-operation stopped perceeding, currendId and/or adressId props are not set.",
          );
          return;
        }
        // @ts-ignore
        office["adress_id"] = this.adressId;
        console.log(this.adressId);

        try {
          await this.officeStore.putOffice(
            office,
            // @ts-ignore
            this.currentId,
            // @ts-ignore
            this.projectId,
            // @ts-ignore
            this.companyId,
          );
          this.$emit("put-office");
        } catch (e) {
          console.warn(
            // @ts-ignore
            `Put of office was not successful, error with message: ${e.message}, thrown`,
          );
          return;
        }
      }
    },
    async deleteData() {
      // @ts-ignore
      if (!this.currentId && this.projectId && this.companyId) {
        console.warn(
          "delete-office operation stoped executing because of missing required data (currentId, projectId, companyId)",
        );
        return;
      }
      try {
        await this.officeStore.deleteOffice(
          // @ts-ignore
          this.currentId,
          // @ts-ignore
          this.projectId,
          // @ts-ignore
          this.companyId,
        );
        this.$emit("delete-office");
      } catch (e) {
        console.warn(
          // @ts-ignore
          `delete-operation was not successful, error with message: ${e.message}, was thrown`,
        );
      }
    },
  },
};
</script>

<style>
.required label::after {
  content: " *";
  color: red;
}
</style>
